<template>
  <div class="analysis-result-lite" v-if="analysis">
    <el-col :lg="12" :xl="8">
      <!-- 整体评分 -->
      <div style="margin: 22px 0 28px 0;">
        <el-row>
          <el-col :span="24">
            <div class="highlight">{{ $t('gpt.overallScore') }} (100)
              <el-tag :type="getScoreType(analysis.overall_score, 100)" size="small">
                {{ analysis.overall_score }}
              </el-tag>
            </div>
          </el-col>
        </el-row>
      </div>

      <!-- 各维度分析 -->
      <el-divider content-position="center">{{ $t('gpt.dimensionalAnalysis') }}</el-divider>
      <el-row class="result-row" v-for="(value, key) in analysis.analysis" :key="key">
        {{ $t("gpt." + key) + " " + $t("gpt.score") + ' (10)' }}
        <el-tag :type="getScoreType(value.score, 10)" size="small" style="margin-left: 8px;">{{ value.score
          }}</el-tag>
      </el-row>
    </el-col>

    <el-col class="hidden-lg-and-down" :xl="8">
      <el-divider content-position="center">{{ $t('gpt.advantage') }}</el-divider>
      <el-row class="result-row">
        <el-col :span="24">
          <div class="content-text" v-for="(strength, index) in analysis.strengths" :key="index">
            <i class="el-icon-check" style="color: #67C23A; margin-right: 8px;"></i>
            {{ strength }}
          </div>
        </el-col>
      </el-row>

      <el-divider content-position="center">{{ $t('gpt.improvements') }}</el-divider>
      <el-row>
        <el-row class="result-row" v-for="(improvement, index) in analysis.improvements" :key="index">
          {{ improvement.category }}
          <el-tag :type="getPriorityType(improvement.priority)" size="small" style="margin-left: 8px;">
            {{ improvement.priority }}
          </el-tag>
        </el-row>
      </el-row>
    </el-col>

    <el-col :lg="12" :xl="8">
      <el-divider class="hidden-lg-and-down" content-position="center">{{ $t('gpt.recommendations') }}</el-divider>
      <el-row class="result-row hidden-lg-and-down">
        <el-col :span="24">
          <div class="content-text">
            <div v-for="(tip, index) in analysis.recommendations.styling_tips" :key="index">
              <i class="el-icon-thumb" style="color: #409EFF; margin-right: 8px;"></i>
              {{ tip }}
            </div>
          </div>
        </el-col>
      </el-row>
      <el-divider class="hidden-xl-only" content-position="center">{{ $t('gpt.improvements') }}</el-divider>
      <el-row>
        <el-row class="result-row hidden-xl-only" v-for="(improvement, index) in analysis.improvements" :key="index">
          {{ improvement.category }}
          <el-tag :type="getPriorityType(improvement.priority)" size="small" style="margin-left: 8px;">
            {{ improvement.priority }}
          </el-tag>
        </el-row>
      </el-row>

      <el-divider content-position="center">{{ $t('gpt.occasion_appropriateness') }}</el-divider>
      <el-row style="margin-bottom: 20px;">
        <el-col :span="24">
          <div style="display: flex; flex-wrap: wrap; gap: 8px;">
            <el-tag v-for="(occasion, index) in analysis.alternative_occasions" :key="index" type="info" size="medium">
              {{ occasion }}
            </el-tag>
          </div>
        </el-col>
      </el-row>
    </el-col>
  </div>
</template>

<script>
import 'element-ui/lib/theme-chalk/display.css';
export default {
  name: 'AnalysisResult',
  props: {
    analysis: {
      type: Object,
      default: null
    }
  },
  methods: {
    // 根据分数获取标签类型
    getScoreType(score, fullScore = 100) {
      if (score >= 80 && fullScore == 100 || score >= 8 && fullScore == 10) return 'success';
      if (score >= 60 && fullScore == 100 || score >= 6 && fullScore == 10) return 'warning';
      return 'danger';
    },

    // 根据优先级获取标签类型
    getPriorityType(priority) {
      if (priority === 'high') return 'danger';
      if (priority === 'medium') return 'warning';
      return '';
    }
  }
};
</script>

<style lang="scss" scoped>
.analysis-result-lite {
  margin: 0 10px 10px 10px;

  .highlight {
    font-weight: bold;
    font-size: 18px;

    .el-tag {
      font-size: 18px;
    }
  }

  .result-row {
    padding: 4px 0;
  }

  .el-divider {
    margin: 14px 0;

    ::v-deep .el-divider__text {
      font-weight: bold !important;
    }
  }
}
</style>